/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useRevokeIncomingEventMutation } from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";
import { generateActionSuccessText } from "~/tools";
import { RefetchOptions, refetchQueryHelper } from "../../helpers";

type Props = {
  refetchQueries: RefetchOptions;
};

export function useRevokeIncomingEvent({ refetchQueries }: Props) {
  const [revokeIncomingEventMutation] = useRevokeIncomingEventMutation({
    onCompleted: () => {
      showSuccess(generateActionSuccessText("Event")()("revoked")());
    },
    onError: (error: Error) => showError(error.message),
    refetchQueries: [refetchQueryHelper(refetchQueries)],
  });

  async function revokeIncomingEvent(eventId: string) {
    await revokeIncomingEventMutation({
      variables: {
        eventId: eventId,
      },
    });
  }

  return revokeIncomingEvent;
}
